import { render, staticRenderFns } from "./notDate.vue?vue&type=template&id=9a99ef64&scoped=true&"
import script from "./notDate.vue?vue&type=script&lang=js&"
export * from "./notDate.vue?vue&type=script&lang=js&"
import style0 from "./notDate.vue?vue&type=style&index=0&id=9a99ef64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a99ef64",
  null
  
)

export default component.exports